import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const AbsenceReasonDeleteDialog = ({ showDeleteDialog, setShowDeleteDialog, selectedReason, handleDelete }) => {
  const { t } = useTranslation();

  return (
  <AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{t('absenceReasons.deleteDialog.title')}</AlertDialogTitle>
        <AlertDialogDescription>
          {t('absenceReasons.deleteDialog.desc', { name: selectedReason?.name })}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
        <AlertDialogAction onClick={handleDelete} className="bg-destructive text-destructive-foreground">
          {t('common.delete')}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
  );
};

export default AbsenceReasonDeleteDialog;
